import { styled, TextField } from '@mui/material';

const RoundTextField = styled(TextField)`
  fieldset {
    border-radius: 14px;
  }
`;

export default RoundTextField;